import { dayOfWeekShort, month, dayOfWeek } from '../../glosary';

export default class ViewTime {
  constructor() {
    if (typeof ViewTime.instance === 'object') {
      return ViewTime.instance;
    }
    ViewTime.instance = this;
    return this;
  }

  clock(language) {
    this.date = new Date();
    this.dayShort = dayOfWeekShort[language][this.date.getDay()];
    this.data = this.date.getDate();
    this.Month = month[language][this.date.getMonth()];
    this.hours = (this.date.getHours() < 10) ? `0${this.date.getHours()}` : this.date.getHours();
    this.minutes = (this.date.getMinutes() < 10) ? `0${this.date.getMinutes()}` : this.date.getMinutes();
    this.seconds = (this.date.getSeconds() < 10) ? `0${this.date.getSeconds()}` : this.date.getSeconds();
    document.querySelector('.data').innerHTML = `${this.dayShort} ${this.data} ${this.Month} ${this.hours} : ${this.minutes} : ${this.seconds}`;
    document.getElementById('tomorrow').innerText = `${dayOfWeek[language][this.date.getDay() + 1]}`;
    document.getElementById('second-day').innerText = `${dayOfWeek[language][this.date.getDay() + 2]}`;
    document.getElementById('third-day').innerText = `${dayOfWeek[language][this.date.getDay() + 3]}`;
    if (this.date.getMonth() <= 1 || this.date.getMonth() === 11) {
      this.timeOfYear = 'Winter';
    } else if (this.date.getMonth() <= 4) {
      this.timeOfYear = 'Spring';
    } else if (this.date.getMonth() <= 7) {
      this.timeOfYear = 'Summer';
    } else if (this.date.getMonth() <= 10) {
      this.timeOfYear = 'Autumn';
    }
  }


  init(language) {
    clearInterval(this.time);
    this.time = setInterval(this.clock, 1000, language);
  }
}
